import { useDispatch } from "react-redux";
import { setRequestAmendment } from "../../features/actuarial/request-amendment/request-amendment.slice";
import { ProposalData } from "../../api/gms/proposal/proposal-api-state";
import { useCallback } from "react";

export const usePopulateRequestAmendment = (proposal?: ProposalData) => {

    const dispatch = useDispatch();

    const populateRequestAmendment = useCallback(() => {
        if(!proposal) return;
        dispatch(setRequestAmendment(proposal.amendment_request))
    }, [dispatch, proposal]);

    return {
        populateRequestAmendment,
    }
}